/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import Group from "vux/src/components/group/index.vue";
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import SearchBar from '@/components/SearchBar';
import FlowList from '@/components/ScrollerList/FlowList';
import { getCustomerList } from '@/api';
import ExtField from '@/components/ExtField';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    SearchBar: SearchBar,
    FlowList: FlowList,
    ExtField: ExtField
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      pageIndex: 0,
      pageSize: 10,
      keyword: '',
      list: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line standard/computed-property-even-spacing
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;

      if (val) {
        this.resetList();
      }
    },
    currValue: function currValue(val) {
      var _this = this;

      this.$emit('input', val);

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
    }
  },
  methods: {
    loadList: function loadList() {
      var _this2 = this;

      getCustomerList({
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize,
        keyword: this.keyword
      }).then(function (res) {
        _this2.$refs['customerList'] && _this2.$refs['customerList'].donePullup();
        _this2.$refs['customerList'] && _this2.$refs['customerList'].donePulldown();

        if (res.success) {
          _this2.list = _this2.list.concat(res.data);

          if (res.data.length < _this2.pageSize) {
            _this2.$refs['customerList'] && _this2.$refs['customerList'].disablePullup();
          }
        }
      });
    },
    resetList: function resetList() {
      this.list = [];
      this.pageIndex = 0;
      this.$refs['customerList'] && this.$refs['customerList'].enablePullup();
      this.loadList();
    },
    onPulldownLoading: function onPulldownLoading() {
      this.resetList();
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    }
  },
  created: function created() {// this.loadList()
  }
};